import { NavLink, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { PAGE_WRAPPER_STYLES } from 'src/styles/pageStyles';
import { cn } from 'src/lib/utils';
import { useAdminCurrentUserQuery } from 'src/generated/graphql';
import { LoadingScreen } from 'src/LoadingScreen';
import { routes } from 'src/routes';
import { AnalyticsPage } from './analytics/AnalyticsPage';
import { OrgManagementPage } from './orgs/OrgManagementPage';

const navLinkStyles =
  'px-1 py-3 text-sm font-medium transition-colors border-b-2 border-transparent hover:text-white';
const activeNavLinkStyles = 'text-white border-white';
const inactiveNavLinkStyles = 'text-slate-400';

export const AdminLayout = () => {
  const location = useLocation();
  const { data: userData, loading: userLoading, error: userError } =
    useAdminCurrentUserQuery();

  if (userLoading) {
    return <LoadingScreen />;
  }

  if (userError) {
    throw userError;
  }

  if (!userData?.currentUser?.isSuperAdmin) {
    return <Redirect to={routes.root.definition} />;
  }

  // Redirect /admin to /admin/analytics
  if (location.pathname === '/admin' || location.pathname === '/admin/') {
    return <Redirect to={routes.adminAnalytics.getPath()} />;
  }

  return (
    <div className="flex flex-col w-full min-h-screen bg-gray-50">
      {/* Dark header with navigation */}
      <header className="bg-slate-800 border-b border-slate-700">
        <div className={cn('flex flex-col', PAGE_WRAPPER_STYLES)}>
          <div className="flex items-center justify-between pt-6 pb-2">
            <h1 className="text-2xl font-semibold text-white tracking-tight">
              Admin Console
            </h1>
          </div>

          {/* Tab navigation */}
          <nav className="flex gap-6 -mb-px">
            <NavLink
              to={routes.adminAnalytics.getPath()}
              className={cn(navLinkStyles, inactiveNavLinkStyles)}
              activeClassName={cn(navLinkStyles, activeNavLinkStyles)}
              isActive={(match, location) =>
                location.pathname.startsWith('/admin/analytics')
              }
            >
              Analytics
            </NavLink>
            <NavLink
              to={routes.adminOrgs.getPath()}
              className={cn(navLinkStyles, inactiveNavLinkStyles)}
              activeClassName={cn(navLinkStyles, activeNavLinkStyles)}
              isActive={(match, location) =>
                location.pathname.startsWith('/admin/orgs')
              }
            >
              Org Management
            </NavLink>
          </nav>
        </div>
      </header>

      {/* Content area */}
      <main className="flex-1">
        <Switch>
          <Route path={routes.adminAnalytics.definition} component={AnalyticsPage} />
          <Route path={routes.adminOrgs.definition} component={OrgManagementPage} />
        </Switch>
      </main>
    </div>
  );
};
